// import dependencies
import React, {
  useState,
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { ClickAwayListener } from "@material-ui/core";
// import assets and scss
import "./formInputWithHeader.scss";
import dropdown_blue from "../../../assets/dropdown_blue.svg";
// import project files
import FocusableDiv from "../FocusableDiv";

const FormInputWithHeader = forwardRef((props, ref) => {
  const {
    title,
    type,
    placeholder,
    value,
    inputType,
    disabled,
    options,
    maxLimit,
    mandatory,
    errorMsg,
    isError,
    isCustomValue,
    allowDecimal,
    selectedOption,
    autoFocus,
    icon,
    handleOnChangeInput,
    handleOnChangeDropdownInput,
  } = props;
  const [openDropdown, setOpenDropdown] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState("bottom");
  const [clickAwayFlag, setClickAwayFlag] = useState(false);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  useImperativeHandle(ref, () => ({
    openDropdown: handleOpenDropdown,
    closeDropdown: handleCloseDropdown,
  }));

  const handleOpenDropdown = () => {
    if (!inputRef.current || !dropdownRef.current) return;

    const inputRect = inputRef.current.getBoundingClientRect();
    const dropdownRect = dropdownRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const spaceBelow = viewportHeight - inputRect.bottom;
    const spaceAbove = inputRect.top;
    const dropdownHeight = dropdownRect.height;
    let position = "bottom";
    if (dropdownHeight > spaceBelow && spaceBelow < spaceAbove) {
      position = "top";
    }
    setDropdownPosition(position);
    if (!disabled) toggleDropdown();
  };

  useEffect(() => {
    setClickAwayFlag(openDropdown ? true : false);
  }, [openDropdown]);
  // Actions ===>

  const toggleDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  const handleCloseDropdown = () => {
    setOpenDropdown(false);
  };

  // <===

  // Display UI ===>

  const inputDropDownUi = () => {
    return (
      <>
        <ClickAwayListener
          onClickAway={() => {
            clickAwayFlag && handleCloseDropdown();
          }}
        >
          <div style={{ position: "relative" }} ref={inputRef}>
            <FocusableDiv
              className="form-input-with-header-dropdown-input"
              onClick={handleOpenDropdown}
              style={{ cursor: disabled ? "not-allowed" : "" }}
            >
              {isCustomValue ? (
                <input
                  placeholder={placeholder}
                  type={type}
                  value={value}
                  autoFocus={true}
                  onChange={handleOnChangeDropdownInput}
                  disabled={disabled}
                  onKeyDown={(e) =>
                    type === "number" &&
                    (e.key?.toLowerCase() === "e" ||
                      e.key === "+" ||
                      e.key === "-" ||
                      (!allowDecimal && e.key === ".")) &&
                    e.preventDefault()
                  }
                  maxLength={maxLimit}
                  className="form-input-with-header-input-field"
                />
              ) : (
                <>
                  {value ? (
                    <div className="form-input-with-header-input-value">
                      {value}
                    </div>
                  ) : (
                    <div className="form-input-with-header-input-placeholder">
                      {placeholder}
                    </div>
                  )}
                </>
              )}
              {!isCustomValue && (
                <div className="form-input-with-header-dropdown-icon">
                  <img
                    src={icon ? icon : dropdown_blue}
                    alt=""
                    style={{
                      transform: openDropdown
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  />
                </div>
              )}
            </FocusableDiv>

            <div
              className={`form-input-with-header-dropdown-cont ${
                dropdownPosition === "top" ? "dropdown-up" : "dropdown-down"
              } ${!openDropdown ? "dropdown-display-hidden" : ""}`}
              ref={dropdownRef}
            >
              {options?.map((item, ind) => (
                <div
                  key={ind}
                  onClick={() => {
                    if (!item?.disabled) {
                      handleOnChangeInput(item);
                    }
                    toggleDropdown();
                  }}
                  className={
                    "form-input-with-header-dropdown-options " +
                    (item.selected || selectedOption === item.value
                      ? "form-input-with-header-dropdown-option-selected"
                      : "") +
                    (item.disabled
                      ? "form-input-with-header-dropdown-options-disabled"
                      : "")
                  }
                >
                  {item.label}
                </div>
              ))}
            </div>
          </div>
        </ClickAwayListener>
      </>
    );
  };

  const formInputUi = () => {
    return (
      <>
        <div className="form-input-with-header-input">
          <input
            placeholder={placeholder}
            type={type}
            value={value}
            onChange={handleOnChangeInput}
            disabled={disabled}
            autoFocus={autoFocus}
            onKeyDown={(e) =>
              type === "number" &&
              (e.key?.toLowerCase() === "e" ||
                e.key === "+" ||
                e.key === "-" ||
                (!allowDecimal && e.key === ".")) &&
              e.preventDefault()
            }
            maxLength={maxLimit}
            className="form-input-with-header-input-field"
          />
        </div>
        {isError && (
          <div className="form-input-with-header-error-msg">{errorMsg}</div>
        )}
      </>
    );
  };

  const displayFormInputWithHeader = () => {
    return (
      <div className="form-input-with-header">
        {title && (
          <div className="form-input-with-header-title">
            {title}
            {mandatory && (
              <span className="form-input-with-header-mandatory">*</span>
            )}
          </div>
        )}
        {inputType === "dropdown" ? inputDropDownUi() : formInputUi()}
      </div>
    );
  };

  // <===

  return <>{displayFormInputWithHeader()}</>;
});

export default FormInputWithHeader;
